<div cdkDropListGroup class="draggable-group">
  <ng-container *ngIf="_draggableLists != null; else missingConfigurations">
    <div *ngFor="let list of _draggableLists" class="draggable-list">
      <div class="draggable-list__header">
        <h4 class="name">{{ list?.header }}</h4>
        <h6 class="description">{{ list?.description }}</h6>
      </div>
      <div
        cdkDropList
        class="draggable-list__drop-list"
        [id]="list?.id != null ? list.id : ''"
        [ngClass]="list?.style?.list"
        [cdkDropListData]="list?.elements"
        [cdkDropListLockAxis]="list?.lockAxis"
        [cdkDropListSortingDisabled]="list?.sorting?.disabled"
        (cdkDropListDropped)="onElementDrop($event)"
      >
        <div
          *ngFor="let item of list?.elements"
          cdkDrag
          class="draggable-item"
          [ngClass]="list?.style?.item"
          [cdkDragDisabled]="item.isDisabled"
        >
          <mat-icon *ngIf="item.isDisabled; else handleIcon">lock</mat-icon>
          <ng-template #handleIcon>
            <mat-icon svgIcon="alt-handle-icon"></mat-icon>
          </ng-template>
          <p>{{ item.value | uppercase }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #missingConfigurations>
  <h3>Missing Configurations</h3>
</ng-template>
